import React from "react";

interface ProofSignatureProps {
  signature: string;
}

const ProofSignature: React.FC<ProofSignatureProps> = ({ signature }) => {
  const displaySignature =
    signature.length > 12
      ? `${signature.substring(0, 6)}...${signature.substring(
          signature.length - 4
        )}`
      : signature;

  return (
    <div className="w-full bg-background-secondary dark:bg-background-secondary-dark rounded-lg">
      <div className="flex flex-row items-center justify-between">
        <p className="text-sm text-text-secondary">Signature</p>
        <div
          className="px-3 py-1 rounded-full text-sm"
          style={{
            backgroundColor: "rgba(65, 209, 149, 0.1)",
            color: "#41D195",
          }}
        >
          {displaySignature}
        </div>
      </div>
    </div>
  );
};

export default ProofSignature;
